import NiceModal, { useModal } from '@ebay/nice-modal-react'
import React from 'react'
import { createMVPModal } from '../Modal'
import { BasicModalView, BasicModalViewProps } from './BasicModalView'

class BasicModal
{
	Show(props: BasicModalViewProps) 
	{
		NiceModal.show(createMVPModal('basic-modal', () =>
		{
			const modal = useModal()

			const viewProps = {
				...props
			}
			viewProps.clickConfirm = () => 
			{
				modal.hide()
				props.clickConfirm?.()
			}

			return <BasicModalView  {...viewProps}/>
		}))
	}
}

const modal = new BasicModal()
export default modal
